import {PrivateRouteDefinition} from "../../infecto-lms-admin/components/core/model/PrivateRouteDefinition";
import {AnswersStatisticScreen} from "../screens/answers-statistic";

export const ANSWERS_STATISTIC_PATH = "/tracking";


export const AnswersStatisticRoutes: PrivateRouteDefinition[] = [
    {
        path:ANSWERS_STATISTIC_PATH,
        element: <AnswersStatisticScreen />,
        requiredPermissions: [
            "AccountPermission_System_Root",
            "UserInAccountPermission_System_Owner",
        ],
    },
];
